import cx from 'classnames'
import { Link } from 'react-router-dom'
import { DataIngestor } from '~/api/onPremAgent/dataIngestorsAPI'
import RightArrowIcon from '~/components/icons/RightArrowIcon'
import cs from './on_prem_agent_breadcrumbs.scss'

export default function OnPremAgentBreadcrumbs({
  className,
  isCreatePage,
  ingestor,
}: {
  className?: string
  isCreatePage?: boolean
  ingestor?: DataIngestor
}) {
  return (
    <nav className={cx(cs.breadcrumbs, className)}>
      <Link key='root' to='/data-ingestors'>
        Data Ingestors
      </Link>
      {isCreatePage ? <CreateCrumb /> : null}
      {ingestor ? <IngestorCrumb ingestor={ingestor} /> : null}
    </nav>
  )
}

function CreateCrumb() {
  return (
    <>
      <RightArrowIcon key='platesep' className={cs.separator} />
      <Link key='root' to='/data-ingestors/create'>
        Create
      </Link>
    </>
  )
}

function IngestorCrumb({ ingestor }: { ingestor: DataIngestor }) {
  return (
    <>
      <RightArrowIcon key='platesep' className={cs.separator} />
      <Link key='root' to={`/data-ingestors/${ingestor.uuid}`}>
        {ingestor.instrument_name}
      </Link>
    </>
  )
}
